import React, { useState, useEffect } from "react";
import Header from "../../../components/Header/Header";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AddIndent = () => {
  const [formData, setFormData] = useState({
    ProjectID: "",
    TypeID: "",
    L1A: false,
    L2: false,
    TaskSchedule: "", // Added TaskSchedule field
  });
  const [projectOptions, setProjectOptions] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const [filteredStages, setFilteredStages] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const enteredBy = useSelector((state) => state.auth.id);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [projects, stages, types] = await Promise.all([
          axios.get(`${API_BASE_URL}/dropdown/mprojects`),
          axios.get(`${API_BASE_URL}/dropdown/mstages`),
          axios.get(`${API_BASE_URL}/dropdown/mindenttypes`),
        ]);
        setProjectOptions(projects.data);
        setStageOptions(stages.data);
        setTypeOptions(types.data);
      } catch (err) {
        console.error("Error fetching dropdown data:", err);
        setError("Failed to load dropdown data.");
      } finally {
        setLoading(false);
      }
    };

    if (enteredBy) fetchData();
  }, [enteredBy]); // Add enteredById to the dependency array

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "ProjectID") {
      const projectStages = stageOptions.filter((stage) =>
        projectOptions.some(
          (project) =>
            project.ProjectID === value && project.StageID === stage.StageID
        )
      );

      setFilteredStages(projectStages);

      // Automatically select the first stage if available
      const defaultStage =
        projectStages.length > 0 ? projectStages[0].StageID : "";

      setFormData((prev) => ({
        ...prev,
        [name]: value,
        StageID: defaultStage, // Automatically set the first stage
      }));
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = {
      UserID: enteredBy,
      ProjectID: formData.ProjectID,
      TypeID: formData.TypeID,
      CreationDate: new Date().toISOString().split("T")[0],
      Status: "Pending for L2 Approval",
      L1A: formData.L1A,
      L2: formData.L2,
      TaskSchedule: formData.TaskSchedule, // Ensure TaskSchedule is included
  };
  

    try {
      const response = await axios.post(
        `${API_BASE_URL}/l2page/indent`,
        dataToSend
      );

      const newIndentRow = {
        IndentID: response.data.indentId,
        ProjectName: projectOptions.find(
          (p) => p.ProjectID === formData.ProjectID
        )?.ProjectName,
        TypeName: typeOptions.find((t) => t.TypeID === formData.TypeID)
          ?.TypeName,
        CreationDate: dataToSend.CreationDate,
        Status: dataToSend.Status,
        L1: formData.L1 ? "Approved" : "Pending",
        L2: formData.L2 ? "Approved" : "Pending",
        PO: "Pending",
        ItemCount: 0,
      };

      navigate("/L2page", { state: { row: newIndentRow } });
    } catch (err) {
      console.error("Error adding indent:", err);
      setError("Failed to add indent.");
    }
  };

  const handleCancel = () => {
    navigate("/L2Page");
  };

  return (
    <div>
      <Header />
      <div style={{ maxWidth: "400px", margin: "0 auto", paddingTop: "2rem" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "450",
            textAlign: "center",
            marginBottom: "1.5rem",
          }}
        >
          Add Indent
        </h1>
        <form onSubmit={handleSubmit}>
          {[
            {
              name: "ProjectID",
              label: "Project",
              options: projectOptions,
              displayKey: "ProjectName",
              valueKey: "ProjectID",
            },
            {
              name: "TypeID",
              label: "Type",
              options: typeOptions,
              displayKey: "TypeName",
              valueKey: "TypeID",
            },
          ].map(({ name, label, options, displayKey, valueKey }) => (
            <div style={{ marginBottom: "1rem" }} key={name}>
              <label
                htmlFor={name}
                style={{ display: "block", fontWeight: "bold" }}
              >
                {label}:
              </label>
              <select
                id={name}
                name={name}
                value={formData[name]}
                onChange={handleInputChange}
                required
                style={{
                  width: "100%",
                  padding: "0.5rem",
                  border: "1px solid #ccc",
                }}
              >
                <option value="">Select {label.toLowerCase()}</option>
                {options.length > 0 ? (
                  options.map((option) => (
                    <option key={option[valueKey]} value={option[valueKey]}>
                      {option[displayKey]}
                    </option>
                  ))
                ) : (
                  <option key="no-options" disabled>
                    No {label.toLowerCase()} available
                  </option>
                )}
              </select>
            </div>
          ))}

          {/* Task Schedule Field */}
          <div style={{ marginBottom: "1rem" }}>
            <label
              htmlFor="TaskSchedule"
              style={{ display: "block", fontWeight: "bold" }}
            >
              Task Schedule:
            </label>
            <input
              type="text"
              id="TaskSchedule"
              name="TaskSchedule"
              value={formData.TaskSchedule}
              onChange={handleInputChange}
              style={{
                width: "100%",
                padding: "0.5rem",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "1rem",
            }}
          >
            <button
              type="submit"
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                padding: "0.5rem 1rem",
                border: "none",
                cursor: "pointer",
              }}
            >
              Submit
            </button>
            <button
              type="button"
              onClick={handleCancel}
              style={{
                backgroundColor: "#ccc",
                color: "#000",
                padding: "0.5rem 1rem",
                border: "none",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </form>
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </div>
  );
};

export default AddIndent;
